export default function IntroductionSection() {
  return (
    <section className="relative bg-background-50 py-20 md:py-28 px-6 md:px-10">
      <div className="max-w-4xl mx-auto text-center">
        <div className="inline-flex items-center gap-2 px-5 py-2 rounded-full border border-foreground-300/40 bg-background-50 mb-10">
          <span className="text-xs md:text-sm font-medium text-foreground-600 tracking-widest uppercase">
            About the Company
          </span>
        </div>

        <div className="space-y-6 text-foreground-800 leading-relaxed">
          <p className="font-heading text-2xl md:text-4xl lg:text-5xl font-normal text-foreground-900 leading-snug">
            We are a professional engineering team
            <span className="inline-flex items-center justify-center w-8 h-8 md:w-10 md:h-10 align-middle mx-1">
              <i className="ri-stack-line text-2xl md:text-3xl text-primary-500"></i>
            </span>
            focused on designing and developing modern digital software solutions
            for the iOS platform
            <span className="inline-flex items-center justify-center w-8 h-8 md:w-10 md:h-10 align-middle mx-1">
              <i className="ri-smartphone-line text-2xl md:text-3xl text-accent-500"></i>
            </span>
            and related technologies.
          </p>
          <p className="text-base md:text-lg text-foreground-700 leading-relaxed max-w-3xl mx-auto">
            We build scalable, maintainable, and high-performance systems with a strong focus
            on usability, stability, and long-term technical quality.
            <span className="inline-flex items-center justify-center w-7 h-7 md:w-8 md:h-8 align-middle mx-1">
              <i className="ri-shapes-line text-xl md:text-2xl text-secondary-500"></i>
            </span>
            Our engineering approach follows modern software practices including clean architecture,
            performance optimization, and user-centered design — ensuring every system
            we deliver is reliable, efficient, and built to last.
          </p>
          <p className="text-base md:text-lg text-foreground-700 leading-relaxed max-w-3xl mx-auto">
            We emphasize continuous innovation, improvement of development workflows,
            and adoption of up-to-date engineering standards. By actively exploring
            new technologies and evolving internal processes, we maintain a high level
            of technical excellence across every engagement.
          </p>
        </div>
      </div>
    </section>
  );
}